import { defineMessages as e } from "react-intl";
var t = e({
  invalidUrlError: {
    id: "groupSharedFeatures.hyperlinkPopover.invalidUrlError",
    defaultMessage: "Please check URL formatting"
  },
  editButton: {
    id: "groupSharedFeatures.hyperlinkPopover.editButton",
    defaultMessage: "Edit"
  },
  unlinkButton: {
    id: "groupSharedFeatures.hyperlinkPopover.unlinkButton",
    defaultMessage: "Unlink"
  },
  applyButton: {
    id: "groupSharedFeatures.hyperlinkPopover.applyButton",
    defaultMessage: "Apply"
  }
});
export { t as messages };